// 🧿 طلسم محافظ فایل

import React from "react";
// Common Components
import {
  Button,
  TextInput,
  DynamicDropdown,
  AddButton,
  Modal,
} from "src/Components";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
// Local Component
import { Additional } from "./TableAdditional";
import AddModal from "./AddModal";
// Utilities
import { toast } from "react-toastify";
import { getBaseInstruments } from "src/Requests/Order/tradeTableRequests";
import {
  getOptionDomainTable,
  getOptionDomainConfig,
  setOptionDomainConfig,
} from "src/Requests/coveredCall";
import { packetErrorHandler } from "src/Utils/requestUtils";
// Types
import {
  IOptionDomainSearchParam,
  OptionDomainReport,
} from "src/Interfaces/coveredCall";

const OptionDomain: React.FC = () => {
  // Local STore
  const [modalMode, setModalMode] = React.useState(false);
  const [refreshFlag, setRefreshFlag] = React.useState(false);
  const [riskFreeRate, setRiskFreeRate] = React.useState<number>();
  const [searchParam, setSearchParam] =
    React.useState<IOptionDomainSearchParam>({} as IOptionDomainSearchParam);

  React.useEffect(() => {
    getOptionDomainConfig()
      .then((res) => {
        setRiskFreeRate(res.riskFreeRate);
      })
      .catch(packetErrorHandler);
  }, []);

  const searchParamChangeHandler = (name: string, value: any) => {
    setSearchParam({ ...searchParam, [name]: value });
  };

  const changeHandler = (_: string, value: any) => {
    setRiskFreeRate(value);
  };

  const setConfig = () => {
    setOptionDomainConfig({ riskFreeRate: riskFreeRate ?? 0 })
      .then((res) => {
        if (res.data) {
          toast.success(res.msg);
        } else toast.error(res.msg);
      })
      .catch(packetErrorHandler);
  };
  return (
    <>
      {modalMode ? (
        <Modal
          title="افزودن دامنه آپشن"
          UI={
            <AddModal
              onClose={() => setModalMode(false)}
              onSuccess={() => setRefreshFlag(true)}
            />
          }
          onClose={() => setModalMode(false)}
        />
      ) : (
        <></>
      )}
      <AddButton onClick={() => setModalMode(true)} />
      <div className="w-full mt-14">
        <div className="flex justify-between items-center mb-4">
          <div className="flex items-end gap-2 w-1/3">
            <TextInput
              label="٪ نرخ بهره"
              name="riskFreeRate"
              onChange={changeHandler}
              value={riskFreeRate?.toString()}
              kind="percent"
              extraLabel
            />
            <Button onClick={setConfig} text="ویرایش" variant="outlined" />
          </div>
          <div className="flex items-center gap-2 w-1/5">
            <DynamicDropdown
              dropdown={{
                name: "baseInstrumentId",
                placeholder: "نماد",
              }}
              getData={() => getBaseInstruments()}
              onChange={searchParamChangeHandler}
              value={searchParam.baseInstrumentId}
            />
          </div>
        </div>
      </div>
      <TableTemplate<IOptionDomainSearchParam, OptionDomainReport>
        TableUI={({ reports, onAction, sortingType, setSortingType }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            refreshFlag={refreshFlag}
            AdditionalBody={Additional}
            sortingType={sortingType}
            setSortingType={setSortingType}
          />
        )}
        refreshTableTime={30000}
        getDataTable={getOptionDomainTable}
        searchParameters={searchParam}
        withSort
      />
    </>
  );
};

export default OptionDomain;
